<template>
  <div data-testid="location-user-selector">
    <v-row class="ma-0" data-testid="location-user-selector__row">
      <v-col cols="12" class="pa-0" v-if="showlocationanduser" data-testid="location-user-selector__active">
        <p class="gray--text pa-0 ma-0 mb-1" data-testid="location-user-selector__active-label">
         Add {{ locationHeader }} and users*
        </p>
        <v-card class="shadow-off border-on" data-testid="location-user-selector__card">
          <v-card-title class="tableHeaderBg d-flex align-center justify-space-between px-2 py-1" data-testid="location-user-selector__header">
            <span data-testid="location-user-selector__selected-location" class="noTransform">{{ getLocationById(selectedLocation) }}</span>
            <v-btn icon color="error" @click="clearLocationAndUsers" v-if="!resolvedIsReadOnly" data-testid="location-user-selector__clear-btn">
              <v-icon data-testid="location-user-selector__clear-icon">mdi-delete</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-2 d-flex flex-column gap-3" data-testid="location-user-selector__body">
            <v-row class="ma-0" data-testid="location-user-selector__preparer-row" no-gutters>
              <v-col cols="12" class="pa-0" data-testid="location-user-selector__preparer-col">
                <lb-profilestack
                  :items="preparerLocal"
                  heading="Preparer"
                  :allUser="usersList"
                  :activeUsers="activeUsers"
                  :readonly="resolvedIsReadOnly"
                  :updateFunction="resolvedIsReadOnly ? null : onPreparerUpdate"
                  data-testid="location-user-selector__preparer-profilestack"
                />
              </v-col>
            </v-row>
            <v-row class="pa-0" data-testid="location-user-selector__approver-row" no-gutters>
              <v-col cols="12" class="pa-0" data-testid="location-user-selector__approver-col">
                <lb-profilestack
                  :items="approverLocal"
                  heading="Approver"
                  :allUser="usersList"
                  :activeUsers="activeUsers"
                  :readonly="resolvedIsReadOnly"
                  :updateFunction="resolvedIsReadOnly ? null : onApproverUpdate"
                  data-testid="location-user-selector__approver-profilestack"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="pa-0" v-else data-testid="location-user-selector__inactive">
        <p class="pa-0 ma-0 mb-2" data-testid="location-user-selector__inactive-label">
          <span>Add {{ locationHeader }} and users*</span>
        </p>
        <div class="border-on all-width d-flex align-center justify-center all-height" style="height: 16vh" data-testid="location-user-selector__inactive-container">
          <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" :disabled="resolvedIsReadOnly" data-testid="location-user-selector__stepper-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" class="d-flex blue--text font-size-xm text-capitalize shadow-off" @click="addlocationanduserflagLocal = 0" :disabled="resolvedIsReadOnly" data-testid="location-user-selector__add-btn">
                <v-icon data-testid="location-user-selector__add-icon">mdi-plus</v-icon>
                <span>Add {{ locationHeader }} and users</span>
              </v-btn>
            </template>
            <v-list style="max-height: 50vh; overflow: hidden; z-index: 13 !important;" class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width" v-if="addlocationanduserflagLocal === 0" data-testid="location-user-selector__step-location">
              <div class="ma-0 all-width" data-testid="location-user-selector__step-location-header-wrapper">
                <div class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1 justify-space-between" data-testid="location-user-selector__step-location-header">
                  <p class="ma-0" data-testid="location-user-selector__step-location-title">Choose {{ locationHeader }}</p>
                  <v-icon color="primary" data-testid="location-user-selector__step-location-info">mdi-information-outline</v-icon>
                </div>
              </div>
              <v-divider data-testid="location-user-selector__step-location-divider"></v-divider>
              <v-list-item style="max-height: 25vh; overflow: scroll" class="d-flex all-width align-start pa-1 ma-0 flex-column" data-testid="location-user-selector__step-location-items">
                <span
                  v-for="(item, index) in sortedLocationList()"
                  :key="`location-${item._id || index}`"
                  class="pa-1 radius-mini cursor-pointer all-width"
                  :class="`${selectedLocationLocal === item._id ? 'border-on caccounting white--text' : 'hoverable-caccounting'}`"
                  @click="selectLocation(item._id)"
                  :data-testid="`location-user-selector__location-option-${item._id}`"
                >{{ item.name }}</span>
              </v-list-item>
              <v-divider data-testid="location-user-selector__step-location-divider-bottom"></v-divider>
              <v-list-item class="d-flex align-center justify-space-between all-width px-1" data-testid="location-user-selector__step-location-actions">
                <v-spacer></v-spacer>
                <v-btn class="black white--text" v-if="selectedLocationLocal" @click="resolvedIsReadOnly ? null : (addlocationanduserflagLocal = 1)" :disabled="resolvedIsReadOnly" data-testid="location-user-selector__step-location-next"><span>Next</span></v-btn>
              </v-list-item>
            </v-list>
            <v-list style="max-height: 50vh; overflow: hidden; z-index: 13 !important;" class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width" v-else-if="addlocationanduserflagLocal === 1" data-testid="location-user-selector__step-preparer">
              <div class="ma-0 all-width" data-testid="location-user-selector__step-preparer-header-wrapper">
                <div class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1" data-testid="location-user-selector__step-preparer-header">
                  <v-btn icon @click="addlocationanduserflagLocal = 0" data-testid="location-user-selector__step-preparer-back"><v-icon>mdi-keyboard-backspace</v-icon></v-btn>
                  <p class="ma-0" data-testid="location-user-selector__step-preparer-title">Choose Preparer</p>
                  <v-icon color="primary" data-testid="location-user-selector__step-preparer-info">mdi-information-outline</v-icon>
                </div>
              </div>
              <v-divider data-testid="location-user-selector__step-preparer-divider"></v-divider>
              <div class="overflow-scroll px-2 userMenu" data-testid="location-user-selector__step-preparer-user-menu">
                <lb-string
                  label=""
                  placeholder="search"
                  append-icon="mdi-magnify"
                  class="mt-1 all-width"
                  hidedetails
                  v-model="usersSearchLocal"
                  data-testid="location-user-selector__step-preparer-search"
                />
                <v-list-item class="d-flex all-width align-start pa-0 ma-0 flex-column" data-testid="location-user-selector__step-preparer-items">
                  <v-checkbox
                    v-for="(item, index) in filteredUsersList"
                    :key="`preparer-${index}-${item._id}`"
                    class="pa-0 ma-0"
                    :value="item._id"
                    v-model="preparerLocal"
                    :disabled="resolvedIsReadOnly"
                    :data-testid="`location-user-selector__step-preparer-checkbox-${item._id}`"
                  >
                    <template v-slot:label>
                      <span class="noTransform">{{ item.name }}</span>
                    </template>
                  </v-checkbox>
                </v-list-item>
              </div>
              <v-list-item class="d-flex align-center justify-space-between all-width px-1" data-testid="location-user-selector__step-preparer-actions">
                <v-spacer></v-spacer>
                <v-btn class="black white--text" v-if="preparerLocal.length > 0" @click="resolvedIsReadOnly ? null : (addlocationanduserflagLocal = 2)" :disabled="resolvedIsReadOnly" data-testid="location-user-selector__step-preparer-next"><span>Next</span></v-btn>
              </v-list-item>
            </v-list>
            <v-list style="max-height: 50vh; overflow: hidden; z-index: 13 !important;" class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width" v-else-if="addlocationanduserflagLocal === 2" data-testid="location-user-selector__step-approver">
              <div class="ma-0 all-width" data-testid="location-user-selector__step-approver-header-wrapper">
                <div class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1" data-testid="location-user-selector__step-approver-header">
                  <v-btn icon @click="addlocationanduserflagLocal = 1" data-testid="location-user-selector__step-approver-back"><v-icon>mdi-keyboard-backspace</v-icon></v-btn>
                  <p class="ma-0" data-testid="location-user-selector__step-approver-title">Choose Approver</p>
                  <v-icon color="primary" data-testid="location-user-selector__step-approver-info">mdi-information-outline</v-icon>
                </div>
              </div>
              <v-divider data-testid="location-user-selector__step-approver-divider"></v-divider>
              <div class="overflow-scroll px-2 userMenu" data-testid="location-user-selector__step-approver-user-menu">
                <lb-string
                  label=""
                  placeholder="search"
                  append-icon="mdi-magnify"
                  class="mt-1 all-width"
                  hidedetails
                  v-model="usersSearchLocal"
                  data-testid="location-user-selector__step-approver-search"
                />
                <v-list-item class="d-flex all-width align-start pa-0 ma-0 flex-column" data-testid="location-user-selector__step-approver-items">
                  <v-checkbox
                    v-for="(item, index) in filteredUsersList"
                    :key="`approver-${index}-${item._id}`"
                    class="pa-0 ma-0"
                    :value="item._id"
                    v-model="approverLocal"
                    :disabled="resolvedIsReadOnly"
                    :data-testid="`location-user-selector__step-approver-checkbox-${item._id}`"
                  >
                    <template v-slot:label>
                      <span class="noTransform">{{ item.name }}</span>
                    </template>
                  </v-checkbox>
                </v-list-item>
              </div>
              <v-list-item class="d-flex align-center justify-space-between all-width px-1" data-testid="location-user-selector__step-approver-actions">
                <v-spacer></v-spacer>
                <v-btn class="black white--text" :disabled="resolvedIsReadOnly || !(preparerLocal.length > 0 && approverLocal.length > 0)" @click="logAndSubmit" data-testid="location-user-selector__step-approver-submit"><span>Submit</span></v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { MESSAGES } from '../../../utils/constants';
import { sortedLocationList } from '../../../utils/taskdetail';
export default {
  name: 'LocationUserSelector',
  props: {
    locationHeader: { type: String, default: 'Location' },
    locationList: { type: Array, default: () => [] },
    usersList: { type: Array, default: () => [] },
    selectedLocation: { type: [String, Number], default: '' },
    preparer: { type: Array, default: () => [] },
    approver: { type: Array, default: () => [] },
    showlocationanduser: { type: Boolean, default: false },
    isReadOnly: { type: Boolean, default: null },
    // Deprecated: use isReadOnly instead. Kept temporarily for backward compatibility.
    isUserEditable: { type: Boolean, default: null },
    metadata: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      selectedLocationLocal: this.selectedLocation,
      preparerLocal: [...this.preparer],
      approverLocal: [...this.approver],
      addlocationanduserflagLocal: 0,
      activeUsers: [],
      usersSearchLocal: '',
    };
  },
  methods: {
    getLocationById(id) {
      // Use store locationMap for O(1) lookup
      const locationMap = this.$store.getters['tasks/getLocationMap'] || {};
      const location = locationMap[id];
      if (location) return location.name;
      // Fallback to prop-based search
      const loc = this.locationList.find(l => l._id === id);
      return loc ? loc.name : '';
    },
    selectLocation(id) {
      this.selectedLocationLocal = id;
      this.usersSearchLocal = ''; // Clear search when moving to next step
      this.$emit('update:selected-location', id);
    },
    async getActiveUsers() {
      // Prefer formDataV3 cached users (already fetched by fetchTask/getAllTasks)
      const formData = this.$store.getters['tasks/getFormDataV3'];
      if (formData && formData.users) {
        this.activeUsers = formData.users.filter(u => u.isActive).map(u => u._id).filter(Boolean);
        return;
      }
      // Fallback: fetch from legacy endpoint
      try {
        await this.$store.dispatch("tasks/getAllUsersWithStatus", { isActiveUsersRequired: true });
        this.activeUsers = this.$store.getters["tasks/getActiveUsersIds"] || [];
      } catch (error) {
        console.error("Error fetching users:", error);
        this.$store.commit("sbError", MESSAGES.FAILED_TO_GET_USERS);
        this.activeUsers = [];
      }
    },
    onPreparerUpdate() {
      if (this.resolvedIsReadOnly) return;
      this.$emit('update:preparer', [...this.preparerLocal]);
    },
    onApproverUpdate() {
      if (this.resolvedIsReadOnly) return;
      this.$emit('update:approver', [...this.approverLocal]);
    },
    clearLocationAndUsers() {
      this.selectedLocationLocal = '';
      this.preparerLocal = [];
      this.approverLocal = [];
      this.addlocationanduserflagLocal = 0;
      this.usersSearchLocal = '';
      this.$emit('update:selected-location', '');
      this.$emit('update:preparer', []);
      this.$emit('update:approver', []);
      this.$emit('update:showlocationanduser', false);
      // Reset local state after delete so stepper is ready for next add
    },
    logAndSubmit() {
      if (!this.resolvedIsReadOnly) this.submitLocationAndUsers();
    },
    
    submitLocationAndUsers() {
      this.$emit('update:selected-location', this.selectedLocationLocal);
      this.$emit('update:preparer', [...this.preparerLocal]);
      this.$emit('update:approver', [...this.approverLocal]);
      this.$emit('update:showlocationanduser', true);
      // Emit custom event for parent to handle backend save
      this.$emit('location-users-submit', {
        location: this.selectedLocationLocal,
        preparer: [...this.preparerLocal],
        approver: [...this.approverLocal]
      });
      // Reset local state after add so stepper is ready for next add
      this.selectedLocationLocal = '';
      this.preparerLocal = [];
      this.approverLocal = [];
      this.addlocationanduserflagLocal = 0;
    },
    sortedLocationList() {
      return sortedLocationList(this.locationList, this.taskListData.metadata?.location);
    },
  },
  created() {
    this.getActiveUsers();
  },
  computed: {
    filteredUsersList() {
      if (!this.usersSearchLocal.trim()) {
        return this.usersList;
      }
      const searchTerm = this.usersSearchLocal.toLowerCase();
      return this.usersList.filter(user =>
        String(user?.name || '').toLowerCase().includes(searchTerm)
      );
    },
    taskListData() {
      return this.$store.getters['tasks/getTaskListData'] || {};
    },
    resolvedIsReadOnly() {
      if (typeof this.isReadOnly === 'boolean') {
        return this.isReadOnly;
      }

      // Deprecated compatibility path: true means editing disabled/read-only.
      if (typeof this.isUserEditable === 'boolean') {
        return this.isUserEditable;
      }

      const routeUserType = (this.$route?.query?.userType || '').toString().toLowerCase();
      if (routeUserType) {
        return routeUserType !== 'manager';
      }

      const user = this.$store?.state?.user || {};
      const roleCandidates = [
        user.userType,
        user.usertype,
        user.role,
        user.user_role,
        user.designation,
      ].map(val => (val || '').toString().toLowerCase()).filter(Boolean);

      return !roleCandidates.includes('manager');
    },
  },
  watch: {
    selectedLocation(val) {
      this.selectedLocationLocal = val;
    },
    preparer(val) {
      this.preparerLocal = [...val];
    },
    approver(val) {
      this.approverLocal = [...val];
    },
    showlocationanduser() {
      // No need to sync to self, handled by parent
    }
  }
};
</script>

<style>
.disabled-edit {
  pointer-events: none;
  opacity: 0.5;
}
.inactive-user-label {
  font-size: 0.75rem;
  color: #ff5252 !important; /* Red color for inactive label */
  margin-left: 4px;
  font-weight: bold;
}
.userMenu {
  max-height: 23vh;
  background-color: var(--color-surface-default);
  overflow: auto;
}
</style>